import React from 'react'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../Components/AuthProvider'
import exit from '../Assets/exit.svg'


function Exit() {
    const navigate = useNavigate()
    const { logOut } = useContext(AuthContext)
    const handleSignOut = () => {
    logOut()
        .then(() => {
        navigate('/')
        })
        .catch((error) => console.error(error))
    }

  return (
    <div className="flex-center cursor-pointer" onClick={handleSignOut}>
        <span>Sair</span>
        <div id="exit-img">
            <img src={exit} alt="Sair" />
        </div>
  </div>
  )
}

export default Exit
